import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "utils/@reduxjs/toolkit";
import {
  IPlanningItems,
  ISelectedPlanningTile,
  PlanningViewBy,
} from "../types";
import { initialState } from "./initialState";

const backlogSlice = createSlice({
  name: "backlogState",
  initialState,
  reducers: {
    fetchBacklogsPlanning: (
      state,
      action: PayloadAction<{
        boardId: string;
        viewBy: PlanningViewBy;
        skipLoading?: boolean;
      }>,
    ) => {
      if (!action.payload.skipLoading) {
        state.isLoading = true;
      }
    },
    setPlanningItems: (state, action: PayloadAction<IPlanningItems>) => {
      state.planningItems = action.payload;
    },
    setSelectedViewType: (
      state,
      action: PayloadAction<PlanningViewBy | null>,
    ) => {
      state.selectedViewType = action.payload;
    },
    setSelectedPlanningTile: (
      state,
      action: PayloadAction<ISelectedPlanningTile | null>,
    ) => {
      state.selectedPlanningTile = action.payload;
    },
    fetchPlanningFilterTickets: (
      state,
      _action: PayloadAction<{ tileId: string; ticketIds: string[] }>,
    ) => {
      state.isPlanningFilterLoading = true;
    },
    setPlanningFilterLoading: (state, action: PayloadAction<boolean>) => {
      state.isPlanningFilterLoading = action.payload;
    },

    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const {
  actions: backlogActions,
  reducer: backlogReducer,
  name: backlogKey,
} = backlogSlice;
